import CryptoJS from 'crypto-js/crypto-js'
import Encrypt from 'encryptlong';
import axios from 'axios';
import store from "../store";
import md5 from 'js-md5';

/**
 * AES加密 ：字符串 key iv  返回base64
 */
export function aesEncrypt(word, key, iv) {

    key = CryptoJS.enc.Utf8.parse(key);
    iv = CryptoJS.enc.Utf8.parse(iv);


    let srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding
    });
    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);

}

/**
 * AES 解密 ：字符串 key iv  返回base64
 *
 */
export function aesDecrypt(word, key, iv) {

    key = CryptoJS.enc.Utf8.parse(key);
    iv = CryptoJS.enc.Utf8.parse(iv);


    let base64 = CryptoJS.enc.Base64.parse(word);
    let src = CryptoJS.enc.Base64.stringify(base64);

    var decrypt = CryptoJS.AES.decrypt(src, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding
    });

    var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);

    return decryptedStr.toString();
}


/* 加密 */
export function rsaEncrypt(data, publicKey) {
    const PUBLIC_KEY = publicKey;
    var encryptor = new Encrypt();
    encryptor.setPublicKey(PUBLIC_KEY);
    // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
    const result = encryptor.encryptLong(data);
    return result;
}


/* 解密 - PRIVATE_KEY - 验证 */
export function rsaDecrypt(data, privateKey) {
    const PRIVATE_KEY = privateKey;
    var encryptor = new Encrypt();
    encryptor.setPrivateKey(PRIVATE_KEY);
    // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
    var result = encryptor.decryptLong(data);
    return result;
}


export function base64Encrypt(data) {
    let wordArray = CryptoJS.enc.Utf8.parse(data);
    return CryptoJS.enc.Base64.stringify(wordArray);
}

export function base64Decrypt(data) {
    let parsedWordArray = CryptoJS.enc.Base64.parse(data);
    return parsedWordArray.toString(CryptoJS.enc.Utf8);
}

export async function getPublicKey() {
    let publicKey = "";
    await axios({
        baseURL: process.env.BASE_API,
        url: '/rsa/publicKey',
        method: 'get'
    }).then((rep) => {
        publicKey = rep.data.data.publicKey;
        store.commit("SET_EFFECTIVE_TIME", rep.data.data.effectiveTime);
        store.commit("SET_PUBLIC_KEY",publicKey);
    }).catch((err) => {
        console.log('err', err);
    });
    return publicKey;
}

export function uuid(len, radix) {
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    var uuid = [], i;
    radix = radix || chars.length;
    if (len) {
        // Compact form
        for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
    } else {
        // rfc4122, version 4 form
        var r;
        // rfc4122 requires these characters
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        uuid[14] = '4';
        // Fill in random data.  At i==19 set the high bits of clock sequence as
        // per rfc4122, sec. 4.1.5
        for (i = 0; i < 36; i++) {
            if (!uuid[i]) {
                r = 0 | Math.random() * 16;
                uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
            }
        }
    }
    return uuid.join('');
}


export async function interceptor(data) {

    let publicKey = store.getters.publicKey;
    let effectiveTime =  store.getters.effectiveTime;
    let publicKeyStoreTime = store.getters.publicKeyStoreTime;
    console.log("effectiveTime",effectiveTime);
    if(publicKey==null || publicKey.length == 0||(effectiveTime != -1 && (effectiveTime + publicKeyStoreTime)<new Date().valueOf())){
        publicKey = await getPublicKey();
    }
    // 2.随机生成key 和 Iv 必须为16位
    let key = uuid(16, 4);
    let iv = uuid(16, 4);

    // 3. 用rsa公钥 对 key 和 iv加密
    let keyEn = rsaEncrypt(key, publicKey);
    let ivEn = rsaEncrypt(iv, publicKey);
    // 4. 用 aes 对请求体加密
    let encryptParam = aesEncrypt(JSON.stringify(data), key, iv);

    // 5. 重新赋值请求体
    return  {
        aIv: ivEn,
        aKey: keyEn,
        hash: md5(publicKey),
        param: encryptParam
    };
}




// WEBPACK FOOTER //
// ./src/utils/encrypt.js